import * as React from 'react';
import { DisplayKipsAdjustment } from 'source/app/presentation/MainPanel/Log/MultiplyKips/LogEntryPopup/Adjustment/DisplayKipsAdjustment';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import { Fonts } from 'source/app/presentation/Shared/Styles/SharedStyles';
import { Or } from '../../../../domain/Or';
import { BannerImages } from '../../../../services/Shared/RenderSwal/BannerImage/BannerImage';
import RenderSwal from '../../../../services/Shared/RenderSwal/RenderSwal';
import { IMultipliedKips } from './IKipsMultiplier';

export function ShowLogEntryPopup(multiplier: IMultipliedKips) {
	const swalDurationInMilliseconds = 1500;

	RenderSwal(
		{
			timer: swalDurationInMilliseconds,
			shockBackgroundColor: Or(multiplier.shockBackgroundColor, 'black'),
			height: `250px`,
			bannerImage: BannerImages.barbute
		},
		<div>
			<Title title={multiplier.title} />
			<Message message={multiplier.message} />
			<DisplayKipsAdjustment
				adjustmentName="Hero's Bonus"
				adjustmentValue={multiplier.earlyBirdAdjustment}
				icon={EGlyphicon["star-empty"]}
			/>
			<DisplayKipsAdjustment
				adjustmentName="Fortune"
				adjustmentValue={multiplier.multiplierAdjustment}
				icon={EGlyphicon.cloud}
			/>
			<DisplayKipsAdjustment
				adjustmentName="Too Far Ahead Penalty"
				adjustmentValue={multiplier.tooFarAheadAdjustment}
				icon={EGlyphicon.tint}
			/>
			<DisplayKipsAdjustment
				adjustmentName="Deep Work Bonus"
				adjustmentValue={multiplier.deepWorkBonusAdjustment}
				icon={EGlyphicon['eye-open']}
			/>
			<ShowFinalKips finalKips={multiplier.finalKips} />
		</div>
	);
}

function Title({ title }: { title: string }) {
	return (
		<div
			{...Style(`showLogEntryPopupTitle`, {
				fontSize: '24px',
				color: 'white',
				marginBottom: '15px',
				...Fonts.iMFell
			})}
		>
			{title}
		</div>
	);
}

function Message({ message }: { message: string }) {
	return (
		<div
			{...Style(`showLogEntryPopupMessage`, {
				color: `darkgray`
			})}
		>
			{message}
		</div>
	);
}

function ShowFinalKips({ finalKips }: { finalKips: number }) {
	return (
		<div
			{...Style(`showFinalKips`, {
				...Fonts.iMFell,
				fontSize: `22px`,
				margin: `10px`
			})}
		>
			{finalKips}₭
		</div>
	);
}
